import Home from "home/components/HomeOrLibraryBrowse"
import { createCardRoutes } from "lib/core/routing/card-routing"
import { loadResource } from "path/middleware"
import Invitations from "./components/Invitations"

export const InvitationsWrapper = (route) => {
  const { card, match } = route

  if (match.params.cohortId) {
    return (
      <Invitations
        card={card}
        context={{
          cohort_id: parseInt(match.params.cohortId),
          community_group_id: null
        }}
      />
    )
  } else if (match.params.resource) {
    const offering =
      window.App.getStore("resourceAdmin").request.getCurriculumOffering()

    return (
      <Invitations
        card={card}
        context={{
          cohort_id: offering?.id,
          community_group_id: null
        }}
      />
    )
  } else {
    return (
      <Invitations
        card={card}
        context={{
          cohort_id: null,
          community_group_id: null
        }}
      />
    )
  }
}

export const invitationCardRoute = {
  invitation: {
    component: InvitationsWrapper,
    middleware: async (route) => {
      if (route.match.params.resource) {
        return loadResource(route)
      }
    }
  }
}

export const schoolRoute = createCardRoutes(
  "/manage/",
  invitationCardRoute,
  Home
)
